module.exports = __webpack_public_path__ + "img/5.c27dfc92.jpg";